export default __webpack_public_path__ + "static/media/baseFrame.7875c6d0.png";